import {
  CONDITION,
  type Conditions,
  Item,
  PROMOTION_TYPE,
  Restrictions,
} from 'typings'
import { SCOPE_OPTIONS } from '../Form/ItemsView/typing'
import type { PromotionBase } from './promotion'

export type ProgressiveDiscountConditions = Pick<
  Conditions,
  | CONDITION.BIN
  | CONDITION.CLUSTER
  | CONDITION.SHIPPING_LOCATION
  | CONDITION.PAYMENT_METHODS
  | CONDITION.UTM
>

export type ProgressiveDiscountConfig = {
  quantity: number
  discount: number
}

export enum ProgressiveDiscount {
  Trigger = 'trigger',
  Benefit = 'benefit',
}

export type ProgressiveDiscountTrigger = {
  [SCOPE_OPTIONS.SKUS]: Item[]
  [SCOPE_OPTIONS.COLLECTIONS]: Item[]
  sameItemsOnly: boolean
}

export type ProgressiveDiscountBenefit = Array<ProgressiveDiscountConfig>

export interface ProgressiveDiscountEffect {
  [ProgressiveDiscount.Trigger]: ProgressiveDiscountTrigger | undefined
  [ProgressiveDiscount.Benefit]: ProgressiveDiscountBenefit | undefined
}

export type ProgressiveDiscountRestrictions = Omit<
  Restrictions,
  'maxItemsPerAttribute' | 'accumulate'
>

export interface ProgressiveDiscountPromotion extends PromotionBase {
  type: PROMOTION_TYPE.PROGRESSIVE
  progressive: ProgressiveDiscountEffect
  conditions: ProgressiveDiscountConditions
  restrictions: ProgressiveDiscountRestrictions
}
